module.exports = __webpack_public_path__ + "static/img/曾彪1.4beed8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/曾彪1.png
// module id = /66X
// module chunks = 1